import { useState } from 'react';

import PropTypes from 'prop-types';

import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { Box, IconButton, Typography } from '@mui/material';

import { copyTextToClipboard } from 'components/Shared/utils/copyToClipboard';

const PrivateInfoCell = ({ value }) => {
  const [showValue, setShowValue] = useState(false);

  const preventEvent = (e) => {
    e.stopPropagation();
    e.preventDefault();
  };

  const onToggleVisibility = (e) => {
    preventEvent(e);
    setShowValue(!showValue);
  };

  const onCopy = (e) => {
    preventEvent(e);
    copyTextToClipboard(value);
  };

  return (
    <Box>
      <Typography sx={{ flexGrow: 1 }} className="crop-long-text">
        {showValue ? value : '*****'}
      </Typography>
      <Box sx={{ display: 'flex', opacity: 0.9, '&:hover': { opacity: 1 } }}>
        <IconButton size="small" onClick={onCopy}>
          <ContentCopyIcon fontSize="small" />
        </IconButton>
        <IconButton onClick={onToggleVisibility} edge="end" size="small">
          {showValue ? (
            <Visibility fontSize="small" />
          ) : (
            <VisibilityOff fontSize="small" />
          )}
        </IconButton>
      </Box>
    </Box>
  );
};

PrivateInfoCell.propTypes = {
  value: PropTypes.string,
};

export default PrivateInfoCell;
